export default __webpack_public_path__ + "static/media/diamond-clarity-2.4b860115.png";